/**
 * The only part of the support widget that is part of the page HTML: a WhatsApp shortcut and the chat button.
 * Light on purpose (no chat logic, no services); the chat itself is SupportWidgetLive, loaded after `load`.
 */
import { MessageCircle } from 'lucide-react';
import { WhatsAppIcon } from '../icons/BrandIcons';
import './SupportWidget.css';

interface SupportLauncherProps {
    onClick: () => void;
    label: string;
    whatsappUrl: string;
    whatsappLabel: string;
    whatsappText: string;
    hasUnread?: boolean;
}

export function SupportLauncher({ onClick, label, whatsappUrl, whatsappLabel, whatsappText, hasUnread }: SupportLauncherProps) {
    return (
        <div className="support-widget">
            <a
                className="sw-whatsapp-quick"
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={whatsappLabel}
                title={whatsappLabel}
            >
                <WhatsAppIcon size={18} title="" />
                <span>{whatsappText}</span>
            </a>
            <button
                className="sw-launcher"
                onClick={onClick}
                aria-label={label}
                title={label}
            >
                <MessageCircle />
                {hasUnread && <span className="sw-launcher-badge" />}
            </button>
        </div>
    );
}

